import { useEffect, useState } from 'react';
import { supabase } from '@/integrations/supabase/client';

export function useRecordPageView() {
  useEffect(() => {
    const today = new Date().toISOString().split('T')[0];
    supabase.rpc('increment_page_view' as any, { view_date_param: today }).then(() => {});
  }, []);
}

export function usePageStats() {
  const [stats, setStats] = useState<{ today: number; monthly: number } | null>(null);

  useEffect(() => {
    async function fetchStats() {
      const today = new Date().toISOString().split('T')[0];
      const monthStart = today.slice(0, 8) + '01';

      const { data } = await (supabase as any)
        .from('page_views')
        .select('view_date, view_count')
        .gte('view_date', monthStart)
        .order('view_date', { ascending: false });

      if (data) {
        const todayRow = data.find((r: any) => r.view_date === today);
        const monthly = data.reduce((sum: number, r: any) => sum + (r.view_count || 0), 0);
        setStats({ today: todayRow?.view_count || 0, monthly });
      }
    }
    fetchStats();
  }, []);

  return stats;
}
